"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Badge = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactstrap = require("reactstrap");
var _propTypes = _interopRequireDefault(require("prop-types"));
const Badge = props => /*#__PURE__*/_react.default.createElement(_reactstrap.Badge, props, props.children);
exports.Badge = Badge;
Badge.defaultProps = {
  pill: false,
  /** Specifies the type of badge */
  color: "primary"
};
Badge.propTypes = {
  /** If set to true, make badges more rounded. */
  pill: _propTypes.default.bool,
  /** Specifies the type of badge */
  color: _propTypes.default.oneOf(["primary", "secondary", "success", "danger", "warning", "info", "light"])
};